import { Box } from '@radix-ui/themes';
import { CommonDialog } from 'components/common/dialogs';
import { ErrorBoundary } from 'components/common/error-boundary';
import { IFullDialog } from 'interfaces/i-dialogs';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { LanguageCode } from 'lib_ts/enums/translation';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useAuthStore } from 'stores/use-auth-store';
import CONTENT_EN from './content-en.md';
import CONTENT_JA from './content-ja.md';
import CONTENT_KO from './content-ko.md';

const COMPONENT_NAME = 'TermsOfUseDialog';

interface IProps {
  show: boolean;
  onClose: () => void;
}

export const TermsOfUseDialog = (props: IProps) => {
  const current = useAuthStore((s) => s.current);
  const [content, setContent] = useState('Please wait...');

  useEffect(() => {
    const c = (() => {
      switch (current.language) {
        case LanguageCode.Japanese: {
          return CONTENT_JA;
        }

        case LanguageCode.Korean: {
          return CONTENT_KO;
        }

        case LanguageCode.English:
        default: {
          return CONTENT_EN;
        }
      }
    })();

    fetch(c)
      .then((res) => res.text())
      .then((txt) => setContent(txt));
  }, [current.language]);

  const DEFAULT_PROPS: IFullDialog = {
    identifier: COMPONENT_NAME,
    width: RADIX.DIALOG.WIDTH.XL,
    vFlexHeight: RADIX.DIALOG.HEIGHT.LG,
    title: 'common.terms-of-use',
    content: (
      <Box className={RADIX.VFLEX.GROW}>
        <ReactMarkdown children={content} />
      </Box>
    ),
    onClose: () => props.onClose(),
  };

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <CommonDialog {...DEFAULT_PROPS} />
    </ErrorBoundary>
  );
};
